var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.206,
    height: 27.859,
    viewBox: "0 0 29.206 27.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cancel",
    "data-name": "Icon metro-cancel",
    d: "M17.173,1.928c-8.065,0-14.6,6.236-14.6,13.93s6.538,13.93,14.6,13.93,14.6-6.236,14.6-13.93-6.538-13.93-14.6-13.93Zm0,25.247A11.6,11.6,0,0,1,5.309,15.858,11.6,11.6,0,0,1,17.173,4.54,11.6,11.6,0,0,1,29.038,15.858,11.6,11.6,0,0,1,17.173,27.175ZM21.737,8.893l-4.563,4.353L12.61,8.893,9.872,11.5l4.563,4.353L9.872,20.211l2.738,2.612,4.563-4.353,4.563,4.353,2.738-2.612-4.563-4.353L24.475,11.5Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.7887484a76fc76cd9866e79d03f98446.svg";
export { ForwardRef as ReactComponent };